'use client';
import Char2VideoForm from './Char2VideoForm';

export default function Character2Video() {
  return <Char2VideoForm />;
}
